/*!
 * Stickyfill – `position: sticky` polyfill
 * v. 2.1.0 | https://github.com/wilddeer/stickyfill
 * MIT License
 */
!(function (a, b) {
  "use strict";

  function c(a, b) {
    if (!(a instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }

  function d(a, b) {
    for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
  }

  function e(a) {
    return parseFloat(a) || 0;
  }

  function f(a) {
    for (var b = 0; a;)(b += a.offsetTop), (a = a.offsetParent);
    return b;
  }

  function g() {
    function c() {
      a.pageXOffset != m.left ?
          ((m.top = a.pageYOffset), (m.left = a.pageXOffset), p.refreshAll()) :
          a.pageYOffset != m.top &&
          ((m.top = a.pageYOffset),
              (m.left = a.pageXOffset),
              n.forEach(function (a) {
                return a._recalcPosition();
              }));
    }

    function d() {
      f = setInterval(function () {
        n.forEach(function (a) {
          return a._fastCheck();
        });
      }, 500);
    }

    function e() {
      clearInterval(f);
    }
    if (!k) {
      (k = !0),
          c(),
          a.addEventListener("scroll", c),
          a.addEventListener("resize", p.refreshAll),
          a.addEventListener("orientationchange", p.refreshAll);
      var f = void 0,
          g = void 0,
          h = void 0;
      "hidden" in b
          ?
          ((g = "hidden"), (h = "visibilitychange")) :
          "webkitHidden" in b &&
          ((g = "webkitHidden"), (h = "webkitvisibilitychange")),
          h ?
              (b[g] || d(),
                  b.addEventListener(h, function () {
                    b[g] ? e() : d();
                  })) :
              d();
    }
  }
  var h = (function () {
        function a(a, b) {
          for (var c = 0; c < b.length; c++) {
            var d = b[c];
            (d.enumerable = d.enumerable || !1),
                (d.configurable = !0),
            "value" in d && (d.writable = !0),
                Object.defineProperty(a, d.key, d);
          }
        }
        return function (b, c, d) {
          return c && a(b.prototype, c), d && a(b, d), b;
        };
      })(),
      i = !1,
      j = "undefined" != typeof a;
  j && a.getComputedStyle ?
      !(function () {
        var a = b.createElement("div");
        ["", "-webkit-", "-moz-", "-ms-"].some(function (b) {
          try {
            a.style.position = b + "sticky";
          } catch (a) {}
          return "" != a.style.position;
        }) && (i = !0);
      })() :
      (i = !0);
  var k = !1,
      l = "undefined" != typeof ShadowRoot,
      m = {
        top: null,
        left: null
      },
      n = [],
      o = (function () {
        function g(a) {
          if ((c(this, g), !(a instanceof HTMLElement)))
            throw new Error("First argument must be HTMLElement");
          if (
              n.some(function (b) {
                return b._node === a;
              })
          )
            throw new Error("Stickyfill is already applied to this node");
          (this._node = a),
              (this._stickyMode = null),
              (this._active = !1),
              n.push(this),
              this.refresh();
        }
        return (
            h(g, [{
              key: "refresh",
              value: function () {
                if (!i && !this._removed) {
                  this._active && this._deactivate();
                  var c = this._node,
                      g = getComputedStyle(c),
                      h = {
                        position: g.position,
                        top: g.top,
                        display: g.display,
                        marginTop: g.marginTop,
                        marginBottom: g.marginBottom,
                        marginLeft: g.marginLeft,
                        marginRight: g.marginRight,
                        cssFloat: g.cssFloat,
                      };
                  if (
                      !isNaN(parseFloat(h.top)) &&
                      "table-cell" != h.display &&
                      "none" != h.display
                  ) {
                    this._active = !0;
                    var j = c.style.position;
                    ("sticky" != g.position && "-webkit-sticky" != g.position) ||
                    (c.style.position = "static");
                    var k = c.parentNode,
                        m = l && k instanceof ShadowRoot ? k.host : k,
                        n = c.getBoundingClientRect(),
                        o = m.getBoundingClientRect(),
                        p = getComputedStyle(m);
                    (this._parent = {
                      node: m,
                      styles: {
                        position: m.style.position
                      },
                      offsetHeight: m.offsetHeight,
                    }),
                        (this._offsetToWindow = {
                          left: n.left,
                          right: b.documentElement.clientWidth - n.right,
                        }),
                        (this._offsetToParent = {
                          top: n.top - o.top - e(p.borderTopWidth),
                          left: n.left - o.left - e(p.borderLeftWidth),
                          right: -n.right + o.right - e(p.borderRightWidth),
                        }),
                        (this._styles = {
                          position: j,
                          top: c.style.top,
                          bottom: c.style.bottom,
                          left: c.style.left,
                          right: c.style.right,
                          width: c.style.width,
                          marginTop: c.style.marginTop,
                          marginLeft: c.style.marginLeft,
                          marginRight: c.style.marginRight,
                        });
                    var q = e(h.top);
                    this._limits = {
                      start: n.top + a.pageYOffset - q,
                      end: o.top +
                          a.pageYOffset +
                          m.offsetHeight -
                          e(p.borderBottomWidth) -
                          c.offsetHeight -
                          q -
                          e(h.marginBottom),
                    };
                    var r = p.position;
                    "absolute" != r &&
                    "relative" != r &&
                    (m.style.position = "relative"),
                        this._recalcPosition();
                    var s = (this._clone = {});
                    (s.node = b.createElement("div")),
                        d(s.node.style, {
                          width: n.right - n.left + "px",
                          height: n.bottom - n.top + "px",
                          marginTop: h.marginTop,
                          marginBottom: h.marginBottom,
                          marginLeft: h.marginLeft,
                          marginRight: h.marginRight,
                          cssFloat: h.cssFloat,
                          padding: 0,
                          border: 0,
                          borderSpacing: 0,
                          fontSize: "1em",
                          position: "static",
                        }),
                        k.insertBefore(s.node, c),
                        (s.docOffsetTop = f(s.node));
                  }
                }
              },
            },
              {
                key: "_recalcPosition",
                value: function () {
                  if (this._active && !this._removed) {
                    var a =
                        m.top <= this._limits.start ?
                            "start" :
                            m.top >= this._limits.end ?
                                "end" :
                                "middle";
                    if (this._stickyMode != a) {
                      switch (a) {
                        case "start":
                          d(this._node.style, {
                            position: "absolute",
                            left: this._offsetToParent.left + "px",
                            right: this._offsetToParent.right + "px",
                            top: this._offsetToParent.top + "px",
                            bottom: "auto",
                            width: "auto",
                            marginLeft: 0,
                            marginRight: 0,
                            marginTop: 0,
                          });
                          break;
                        case "middle":
                          d(this._node.style, {
                            position: "fixed",
                            left: this._offsetToWindow.left + "px",
                            right: this._offsetToWindow.right + "px",
                            top: this._styles.top,
                            bottom: "auto",
                            width: "auto",
                            marginLeft: 0,
                            marginRight: 0,
                            marginTop: 0,
                          });
                          break;
                        case "end":
                          d(this._node.style, {
                            position: "absolute",
                            left: this._offsetToParent.left + "px",
                            right: this._offsetToParent.right + "px",
                            top: "auto",
                            bottom: 0,
                            width: "auto",
                            marginLeft: 0,
                            marginRight: 0,
                          });
                      }
                      this._stickyMode = a;
                    }
                  }
                },
              },
              {
                key: "_fastCheck",
                value: function () {
                  this._active &&
                  !this._removed &&
                  (Math.abs(f(this._clone.node) - this._clone.docOffsetTop) > 1 ||
                      Math.abs(
                          this._parent.node.offsetHeight - this._parent.offsetHeight
                      ) > 1) &&
                  this.refresh();
                },
              },
              {
                key: "_deactivate",
                value: function () {
                  var a = this;
                  this._active &&
                  !this._removed &&
                  (this._clone.node.parentNode.removeChild(this._clone.node),
                      delete this._clone,
                      d(this._node.style, this._styles),
                      delete this._styles,
                  n.some(function (b) {
                    return (
                        b !== a && b._parent && b._parent.node === a._parent.node
                    );
                  }) || d(this._parent.node.style, this._parent.styles),
                      delete this._parent,
                      (this._stickyMode = null),
                      (this._active = !1),
                      delete this._offsetToWindow,
                      delete this._offsetToParent,
                      delete this._limits);
                },
              },
              {
                key: "remove",
                value: function () {
                  var a = this;
                  this._deactivate(),
                      n.some(function (b, c) {
                        if (b._node === a._node) return n.splice(c, 1), !0;
                      }),
                      (this._removed = !0);
                },
              },
            ]),
                g
        );
      })(),
      p = {
        stickies: n,
        Sticky: o,
        forceSticky: function () {
          (i = !1), g(), this.refreshAll();
        },
        addOne: function (a) {
          if (!(a instanceof HTMLElement)) {
            if (!a.length || !a[0]) return;
            a = a[0];
          }
          for (var b = 0; b < n.length; b++)
            if (n[b]._node === a) return n[b];
          return new o(a);
        },
        add: function (a) {
          if ((a instanceof HTMLElement && (a = [a]), a.length)) {
            for (
                var b = [],
                    c = function (c) {
                      var d = a[c];
                      return d instanceof HTMLElement ?
                          n.some(function (a) {
                            if (a._node === d) return b.push(a), !0;
                          }) ?
                              "continue" :
                              void b.push(new o(d)) :
                          (b.push(void 0), "continue");
                    },
                    d = 0; d < a.length; d++
            ) {
              c(d);
            }
            return b;
          }
        },
        refreshAll: function () {
          n.forEach(function (a) {
            return a.refresh();
          });
        },
        removeOne: function (a) {
          if (!(a instanceof HTMLElement)) {
            if (!a.length || !a[0]) return;
            a = a[0];
          }
          n.some(function (b) {
            if (b._node === a) return b.remove(), !0;
          });
        },
        remove: function (a) {
          if ((a instanceof HTMLElement && (a = [a]), a.length))
            for (
                var b = function (b) {
                      var c = a[b];
                      n.some(function (a) {
                        if (a._node === c) return a.remove(), !0;
                      });
                    },
                    c = 0; c < a.length; c++
            )
              b(c);
        },
        removeAll: function () {
          for (; n.length;) n[0].remove();
        },
      };
  i || g(),
      "undefined" != typeof module && module.exports ?
          (module.exports = p) :
          j && (a.Stickyfill = p);
})(window, document);

// Print an HTML element
function printElement(elem, append, delimiter) {
  var domClone = elem.cloneNode(true);

  var $printSection = document.getElementById("printSection");

  if (!$printSection) {
    var $printSection = document.createElement("div");
    $printSection.id = "printSection";
    document.body.appendChild($printSection);
  }

  var visibleDescriptions = document.querySelectorAll(
      '[name="img-description"]'
  );
  var descriptions = domClone.querySelectorAll('[name="img-description"]');
  for (i = 0; i < descriptions.length; ++i) {
    descriptions[i].style.height =
        visibleDescriptions[i].scrollHeight + 12 + "px";
  }

  if (append !== true) {
    $printSection.innerHTML = "";
  } else if (append === true) {
    if (typeof delimiter === "string") {
      $printSection.innerHTML += delimiter;
    } else if (typeof delimiter === "object") {
      $printSection.appendChlid(delimiter);
    }
  }

  $printSection.appendChild(domClone);
}

function isIE() {
  ua = navigator.userAgent;
  /* MSIE used to detect old browsers and Trident used to newer ones*/
  var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

  return is_ie;
}

// Remove comments if debouncing is used.
// Function to limit the rate at which a function can fire.
var debounce = function (func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

jQuery(document).ready(function ($) {
  function isNearViewport(element, offset) {
    var docViewTop = $(window).scrollTop() + offset;
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(element).offset().top;

    return elemTop <= docViewBottom;
  }

  var lazyVideos = debounce(
      function () {
        $.each($(".lazy-video"), function () {
          if (isNearViewport($(this), 600)) {
            $(this).removeClass("lazy-video");
            var iframe = $(this).find("iframe");

            iframe.attr("src", iframe.attr("data-src"));
            iframe.attr("data-src", "");
          }
        });
      },
      100,
      true
  );

  $(window).on("scroll", lazyVideos);

  if ($(".exercise-content").length > 0) {
    Stickyfill.add($(".exercise-content .nav-tabs"));

    $("body").scrollspy({
      target: ".exercise-content",
      offset: 50
    });
  }

  var $docEl = $("html, body"),
      $wrap = $(".content"),
      bodyScrollTop,
      bodyLocked = false;

  $.lockBody = function () {
    if (window.pageYOffset) {
      bodyScrollTop = window.pageYOffset;

      $wrap.css({
        top: -bodyScrollTop,
      });
    }

    $docEl.css({
      height: "100%",
      overflow: "hidden",
    });
    bodyLocked = true;
  };

  $.unlockBody = function () {
    $docEl.css({
      height: "",
      overflow: "",
    });

    $wrap.css({
      top: "",
    });

    window.scrollTo(0, bodyScrollTop);
    window.setTimeout(function () {
      bodyScrollTop = null;
    }, 0);
    bodyLocked = false;
  };

  // Mobile menu
  $menubar = $(".navbar-fixed-top .navbar-header");
  $menu = $(".t3-navbar-collapse");
  $desktopMenu = $(".t3-navbar");
  $body = $("html, body");
  $menuLinks = $(".t3-navbar-collapse .menu li a");

  // iOS "back" functionality fix
  $menuLinks.not("[data-toggle='dropdown']").on("click", function () {
    $(".navbar-toggle").toggleClass("open");
    $("body").toggleClass("nav-open");
    $(".t3-navbar-collapse").toggleClass("opened");
    if ($(".navbar-toggle").hasClass("open")) {
      setTimeout(function () {
        $.lockBody();
      }, 250);
    } else {
      $.unlockBody();
    }
  });

  // Scroll to element on link click
  var scrollLink = function (event, link) {
    var dataTarget = $(link).closest(".scroll-to").data("target");
    var addHash = $(link).closest(".scroll-to").data("add-hash");
    var offset = $(link).closest(".scroll-to").data("offset");
    $el = $(link).attr("href");

    if (addHash) {
      var id = $($el).attr("id");
      var target = $($el);
      target.attr("id", "");
      document.location.hash = $el;
      target.attr("id", id);
    }

    if (event) {
      event.preventDefault();
    }

    if (dataTarget) {
      $el = $(dataTarget);
    }

    if (!offset && offset != 0) {
      offset = 40;
    }

    var pos;

    if ($($el).length) {
      pos = $($el).offset().top - offset;
    } else {
      pos = $(window).scrollTop();
    }

    $("html, body").animate({
          scrollTop: pos,
        },
        500
    );

    return false;
  };

  // Function to get max menu height
  getMaxMenuHeight = function () {
    var winH = window.innerHeight;

    return winH;
  };

  // Edit menu height
  calculateMenuHeight = function () {
    // Works only on mobile
    if ($(window).width() < 992) {
      var menuH = getMaxMenuHeight();
      $menu.css({
        "max-height": menuH + "px"
      });
      $menu.css({
        height: menuH + "px"
      });
    } else if (bodyLocked) {
      $.unlockBody();
    }
  };

  calculateMenuHeight();

  $desktopMenu.find(".dropdown").hover(
      function () {
        $(this).find('[data-toggle="dropdown"]').attr("aria-expanded", true);
        $(this).addClass("open");
      },
      function () {
        $(this).find('[data-toggle="dropdown"]').attr("aria-expanded", false);
        $(this).removeClass("open");
      }
  );

  $(".article-spy .scroll-to").on("click", function (e) {
    if ($(window).width() < 992) {
      var link = this;
      e.preventDefault();
      e.stopPropagation();
      $(".article-spy .js-active").removeClass("js-active");

      $(".article-links-toggle").trigger("click");

      setTimeout(function () {
        scrollLink(e, link);
      }, 50);
    }
  });

  // Scroll link
  $(".scroll-to").on("click", function (e) {
    scrollLink(e, this);
  });

  setTimeout(function () {
    if (location.hash) {
      /* we need to scroll to the top of the window first, because the browser will always jump to the anchor first before JavaScript is ready, thanks Stack Overflow: http://stackoverflow.com/a/3659116 */
      window.scrollTo(0, 0);
      target = location.hash.split("#");
      scrollLink(null, $("a[href*=#" + target[1] + "]"));
    }
  }, 1);

  // Navbar toggle
  $(".navbar-toggle").click(function () {
    $(this).toggleClass("open");
    $("body").toggleClass("nav-open");
    $(".t3-navbar-collapse").toggleClass("opened");
    if ($(this).hasClass("open")) {
      setTimeout(function () {
        $.lockBody();
      }, 250);
    } else {
      $.unlockBody();
    }
  });

  var vh = window.innerHeight;
  $(".header-large").css("height", vh);
  $(".modal-dialog").css("max-height", vh);

  $(window).on("orientationchange", function () {
    setTimeout(function () {
      $(".header-large").css("height", window.innerHeight);
      $(".modal-dialog").css("max-height", window.innerHeight);
    }, 100);
  });
  $(window).on("resize", function () {
    $(".modal-dialog").css("max-height", window.innerHeight);
  });

  // Tooltips
  $(".t3-content a:not([class])[title]").tooltip();
  $(document).on("click", ".t3-content a:not([class])[title]", function (e) {
    e.preventDefault();
  });

  // Article nav toggle
  $(".article-links-toggle").on("click", function () {
    $(this).toggleClass("open");
    $(".article-links").toggleClass("opened");

    var activeLink = $(".article-links .active");

    if ($(this).hasClass("open")) {
      setTimeout(function () {
        $.lockBody();
        activeLink.addClass("js-active");
      }, 250);
    } else {
      $.unlockBody();
      activeLink.removeClass("js-active");
      $(".article-spy").css({
        "max-height": "",
        height: "",
      });
    }
  });

  // Article nav affix
  if ($(".article-links").length > 0) {
    var timer;
    Stickyfill.add($(".article-spy .article-links"));

    $("body").scrollspy({
      target: ".article-spy",
      offset: 50,
    });

    $(window).on("resize", function () {
      $(".article-spy .js-active").removeClass("js-active");

      if (!$(".article-links").hasClass("opened")) {
        $(".article-links").css("transition", "none");
        clearTimeout(timer);
        timer = setTimeout(function () {
          $(".article-links").css("transition", "");
        }, 50);
      }
    });

    var articleNavTimeout;

    $(window).on("scroll resize", function () {
      if (!articleNavTimeout) {
        articleNavTimeout = setTimeout(function () {
          $(".article-spy").css({
            "max-height": window.innerHeight + "px",
            height: window.innerHeight + "px",
          });

          if ($(".article-spy").hasClass("opened")) {
            $("html, body").scrollTop(0);
          }
          articleNavTimeout = null;
        }, 250);
      }
    });
  }

  $(".header-large").css(
      "min-height",
      $(".header-large > .container").outerHeight() + 160
  );

  $(window).on("resize", function () {
    setTimeout(function () {
      calculateMenuHeight();
    }, 150);
  });

  var scrollTimeout;

  $(window).on("scroll resize", function () {
    if (!scrollTimeout) {
      scrollTimeout = setTimeout(function () {
        calculateMenuHeight();

        if ($(".t3-navbar-collapse").hasClass("opened")) {
          $("html, body").scrollTop(0);
        }
        scrollTimeout = null;
      }, 250);
    }
  });

  // Slick sliders
  $slickSliderEl = $(".slick-gallery");
  $categorySliderParent = $(".slick-gallery").parent();
  $slickSliderElCopy = $categorySliderParent.html();
  var slickOptions = {
    draggable: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 3,
      },
    },
      {
        breakpoint: 767,
        settings: {
          slidesToScroll: 2,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  };

  $slickSliderEl.slick(slickOptions).data("slick-enabled", 1);

  // Text collapse
  $(document).on("click", ".collapse-text-toggle", function (e) {
    var collapseWrapper = $(this).closest(".collapse-text");
    collapseWrapper
        .css("height", collapseWrapper.find(".collapse-text-wrap").height())
        .addClass("open");
    setTimeout(function () {
      collapseWrapper.css("height", "");
    }, 300);
  });

  modalContentSwitched = false;
  original = "";

  $(document).on("click", ".switch-modal-content", function (e) {
    e.preventDefault();

    if (!modalContentSwitched) {
      modalContentSwitched = true;
      original = $(this).closest(".modal").clone();
      original.removeClass("in");
      original.css({
        display: "",
        "padding-right": ""
      });
      $(this).closest(".js-article-row").append(original);
      $(this).closest(".modal").attr("id", "clonedModal");
    }

    var modal = $($(this).attr("href"));
    $(this).closest(".modal-content").scrollTop(0);
    $(this).closest(".modal-content").html(modal.find(".modal-content").html());
  });

  $(document).on("hidden.bs.modal", ".js-article-row .modal", function () {
    if (modalContentSwitched) {
      modalContentSwitched = false;
      $("#clonedModal").remove();
    }
  });

  // Selecting question option
  $(document).on("change", ".excercise-option input", function () {
    $(this).parents(".excercise").addClass("answered");
    $(this)
        .parents(".excercise")
        .find(".excercise-option")
        .each(function () {
          var correct = $(this).closest(".excercise-option").data("ica");
          var selected = $(this).find("input").is(":checked");
          var className =
              (correct && selected) || (!selected && !correct) ?
                  "correct" :
                  "not-correct";
          $(this).addClass(className);

          if (correct) {
            $(this).addClass("orig-correct");
          }

          $(this).find("input").prop("disabled", true);
        });
  });

  $(document).on("click", 'a[href="#reset-exercise"]', function (e) {
    e.preventDefault();

    const exercise = $(this).closest(".exercise[id^=exercise-]");
    const exerciseId = exercise.attr('id');

    $.get(window.location.href, function (data) {
      let exerciseData = $(data).find('#' + exerciseId + '').html();
      $('#' + exerciseId + '').html(exerciseData);
      $('img', exercise).each(function () {
        let src = $(this).data('src');
        $(this).attr('src', src);
      });
      initContentExercises();
    });
  });

  $("iframe").each(function () {
    if (!$(this).parent().hasClass("embed-responsive")) {
      $(this).wrap(
          '<div class="embed-responsive embed-responsive-16by9"></div>'
      );
    }
  });

  function initContentExercises() {
    if ($(".timeline-draggable").length > 0) {
      $(".timeline-draggable").draggable({
        revert: "invalid",
        snap: false,
        opacity: 1,
        cursor: "grabbing",
        revert: function () {
          $(this).data("uiDraggable").originalPosition = {
            left: $(this).data("uiDraggable").originalPosition.left,
            top: $(this).data("uiDraggable").position.top,
          };

          return true;
        },
      });
    }

    const droppableOptions = {
      hoverClass: "ui-state-hover",
      cursor: "grabbing",
      tolerance: "pointer",
      drop: function (event, ui) {
        var sourceValue = $(ui.draggable).html(),
            itemWrapper = $('<div class="drop-item" />').append(sourceValue),
            dropArea = $(this),
            id = dropArea.attr("data-id"),
            idString = String(dropArea.attr("data-ids")),
            draggableId = $(ui.draggable).data("id");

        if (typeof id == "undefined") {
          ids = idString.split(",");

          var idCount = ids.length,
              group = dropArea.closest(".timeline-group"),
              newDroppable = group.clone(),
              newGroup = group.clone();

          newGroup.removeClass("empty");

          // remove droppable area from new group
          newGroup.find(".w-100").remove();

          var beforeIds = idString,
              afterIds = "0",
              newIds = idString.replace(draggableId, "0");

          if (newIds.indexOf("0,") == 0) {
            beforeIds = "0";
            afterIds = newIds.substring(2);
          } else if (newIds.indexOf(",0") == newIds.length - 2) {
            beforeIds = newIds.replace(",0", "");
          } else if (newIds.indexOf(",0,") !== -1) {
            newIds = newIds.split(",0,");
            beforeIds = newIds[0];
            afterIds = newIds[1];
          }

          dropArea.attr("data-ids", beforeIds);
          newDroppable.find(".timeline-droppable").attr("data-ids", afterIds);

          for (i = 0; i < idCount; i++) {
            id = ids[i];

            if (draggableId == id) {
              $(ui.draggable).addClass("ui-used");

              itemWrapper = itemWrapper.find(".event");
              itemWrapper.removeClass("hidden");

              newGroup.html(itemWrapper);

              var index = ids.indexOf(draggableId);
              ids.splice(index, 1);

              // insert new group after droppable area
              group.after(newGroup);

              // create a new droppable area after new group
              newGroup.after(newDroppable);
              newDroppable
                  .find(".timeline-droppable")
                  .droppable(droppableOptions);
              break;
            }
          }

          // If didn't find a match
          if (i == idCount) {
            dropArea.addClass("error");
            setTimeout(function () {
              dropArea.removeClass("error");
            }, 500);
          }
        }
        // Only accept correct answers
        else if (id == draggableId) {
          $(ui.draggable).addClass("ui-used");
          dropArea.html(itemWrapper);
          // If didn't find a match
        } else if (id != draggableId) {
          dropArea.addClass("error");

          setTimeout(function () {
            dropArea.removeClass("error");
          }, 500);
        }

        $("body").css("cursor", "");
      },
    };

    if ($(".timeline-droppable").length > 0) {
      $(".timeline-droppable").droppable(droppableOptions);
    }
  }

  if ($(".exercise-drag-drop").length > 0) {
    let isAdvancedUpload = (function () {
      let div = document.createElement("div");
      return (
          ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
          "FormData" in window &&
          "FileReader" in window
      );
    })();

    function getOrientation(file, callback) {
      var reader = new FileReader();

      reader.onload = function (e) {
        var view = new DataView(e.target.result);

        if (view.getUint16(0, false) != 0xffd8) {
          return callback(-2);
        }

        let length = view.byteLength,
            offset = 2;

        while (offset < length) {
          if (view.getUint16(offset + 2, false) <= 8) return callback(-1);
          let marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xffe1) {
            if (view.getUint32((offset += 2), false) != 0x45786966) {
              return callback(-1);
            }

            let little = view.getUint16((offset += 6), false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            let tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) == 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xff00) != 0xff00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }

        return callback(-1);
      };

      reader.readAsArrayBuffer(file);
    }

    function resetOrientation(srcBase64, srcOrientation, callback) {
      let img = new Image();

      img.onload = function () {
        let width = img.width,
            height = img.height,
            canvas = document.createElement("canvas"),
            ctx = canvas.getContext("2d");

        // set proper canvas dimensions before transform & export
        if (4 < srcOrientation && srcOrientation < 9) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }

        // transform context before drawing image
        switch (srcOrientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0);
            break;
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height);
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.transform(0, 1, -1, 0, height, 0);
            break;
          case 7:
            ctx.transform(0, -1, -1, 0, height, width);
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width);
            break;
          default:
            break;
        }

        // draw image
        ctx.drawImage(img, 0, 0);

        // export base64
        callback(canvas.toDataURL());
      };

      img.src = srcBase64;
    }

    function processFile(target, file) {
      getOrientation(file, function (orientation) {
        let reader = new FileReader();

        // Preview image
        reader.onload = function (e) {
          resetOrientation(e.target.result, orientation, function (image) {
            target.attr("src", image).removeClass("hidden");
          });
        };

        reader.readAsDataURL(file);
      });
    }

    if (isAdvancedUpload) {
      $dragdropAreas = $(".drop-placeholder");

      $(document)
          .on(
              "drag dragstart dragend dragover dragenter dragleave drop",
              ".drop-placeholder",
              function (e) {
                e.preventDefault();
                e.stopPropagation();
              }
          )
          .on("dragover dragenter", ".drop-placeholder", function () {
            $(this).addClass("is-dragover");
          })
          .on("dragleave dragend drop", ".drop-placeholder", function () {
            $(this).removeClass("is-dragover");
          })
          .on("drop", ".drop-placeholder", function (e) {
            // We only need one image
            if (
                e.originalEvent.dataTransfer.files &&
                e.originalEvent.dataTransfer.files[0]
            ) {
              var droppedFile = e.originalEvent.dataTransfer.files[0];
              $(this).addClass("has-image");
              $(this).parents(".drag-drop-wrap").addClass("has-image");
              processFile($(this).find(".preview-image"), droppedFile);
            }
          });
    } else {
      $(".js-drop-wrap .drop-placeholder .lead").addClass("hidden");
      $(".js-drop-wrap .drop-placeholder .lead.no-drop").removeClass("hidden");
    }

    $(document).on("change", ".image-drop", function () {
      $fileInput = $(this)[0];

      if ($fileInput.files && $fileInput.files[0]) {
        $(this)
            .closest(".js-drop-wrap")
            .find(".drop-placeholder")
            .addClass("has-image");
        $(this).parents(".drag-drop-wrap").addClass("has-image");
        processFile(
            $(this).closest(".js-drop-wrap").find(".preview-image"),
            $fileInput.files[0]
        );
      }
    });
  }

  $(".download-exercise-pdf").on("click", function (e) {
    e.preventDefault();

    // If row doesn't have an image, then ignore it in print
    $(this)
        .closest(".exercise-wrap")
        .find(".drag-drop-wrap")
        .each(function () {
          if (!$(this).hasClass("has-image")) {
            $(this).attr("data-html2canvas-ignore", true);
          } else {
            $(this).removeAttr("data-html2canvas-ignore");
          }
        });

    if (isIE()) {
      // Use regular print option for internet explorer to avoid memory issues
      printElement($(this).closest(".exercise-wrap").find(".printable")[0]);
      window.print();
    } else {
      const downloadButton = $(this);

      downloadButton.find(".material-icons").toggleClass("hidden");
      const exerciseWrap = $(this).closest(".exercise-wrap");
      // generate image from exercise and add it to pdf
      html2canvas(exerciseWrap.find(".printable")[0], {
        onclone: function (document) {
          const descriptions = document.querySelectorAll(
              '[name="img-description"]'
          );
          for (i = 0; i < descriptions.length; ++i) {
            descriptions[i].style.height =
                descriptions[i].scrollHeight + 12 + "px";
          }
        },
      }).then(function (canvas) {
        const width = canvas.width;
        const height = canvas.height;

        // calculate image height in mm
        const widthPPM = width / 180;
        const heightMM = height / widthPPM;

        // calculate pdf height in points
        const pdfHeight = (heightMM + 30);

        // calculate pdf orientation
        const orientation = pdfHeight > 250 ? "portrait" : "landscape";

        // use custom height, otherwise text might get cut off
        const pdf = new jsPDF({
          orientation: orientation,
          unit: "mm",
          format: [pdfHeight, 250],
        });

        const pdfTitle = exerciseWrap.find('[name="exercise-title"]').val();
        pdf.setProperties({
          title: pdfTitle,
        });
        // add generated image to our pdf
        pdf.addImage(
            canvas.toDataURL("image/jpeg", 1.0),
            "JPEG",
            15,
            15,
            180,
            heightMM
        );
        pdf.save(pdfTitle + ".pdf");

        downloadButton.find(".material-icons").toggleClass("hidden");

        const exercise = downloadButton.closest(".exercise");
        const exerciseId = exercise.attr('id');

        if ($('#modal-' + exerciseId).length != 0) {
          $('#modal-' + exerciseId).modal('show');
        }
      });
    }
  });

  $(".download-chapter-pdf").on("click", function (e) {
    e.preventDefault();

    const chapter = $("#exercise.chapter.printable");
    $('div:not(.match-card) video', chapter).each(function() {
      $(this).attr("data-html2canvas-ignore", true);
    });

    $('.keyword', chapter).each(function() {
      $(this).css("background-color", "#fff");
    });

    if (isIE()) {
      // Use regular print option for internet explorer to avoid memory issues
      printElement($(this).closest(".chapter.printable"));
      window.print();
    } else {
      const downloadButton = $(this);

      downloadButton.find(".material-icons").toggleClass("hidden");
      // generate image from exercise and add it to pdf
      html2canvas(chapter[0], {
        onclone: function (document) {
          const descriptions = document.querySelectorAll(
              '[name="img-description"]'
          );
          for (i = 0; i < descriptions.length; ++i) {
            descriptions[i].style.height =
                descriptions[i].scrollHeight + 12 + "px";
          }
        },
      }).then(function (canvas) {
        const width = canvas.width;
        const height = canvas.height;

        // calculate image height in mm
        const widthPPM = width / 180;
        const heightMM = height / widthPPM;

        // calculate pdf height in points
        const pdfHeight = (heightMM + 30);

        // calculate pdf orientation
        const orientation = pdfHeight > 250 ? "portrait" : "landscape";

        // use custom height, otherwise text might get cut off
        const pdf = new jsPDF({
          orientation: orientation,
          unit: "mm",
          format: [pdfHeight, 250],
        });

        const pdfTitle = chapter.find('[name="chapter-title"]').val();
        pdf.setProperties({
          title: pdfTitle,
        });
        // add generated image to our pdf
        pdf.addImage(
            canvas.toDataURL("image/jpeg", 1.0),
            "JPEG",
            15,
            15,
            180,
            heightMM
        );
        pdf.save(pdfTitle + ".pdf");

        $('.keyword', chapter).each(function() {
          $(this).css("background-color", "rgba(255, 255, 255, 0.95)");
        });

        downloadButton.find(".material-icons").toggleClass("hidden");

        $('#download-chapter .bonus-content.hidden').removeClass('hidden');
      });
    }
  });

  $(".btn-clone-row").on("click", function (e) {
    e.preventDefault();

    const exerciseWrap = $(this).closest(".exercise-wrap");
    const clonableRow = exerciseWrap.find(".js-clone-row");
    let clonedRow = clonableRow.clone();

    clonedRow = $(
        clonedRow.html(function (index, htmlstring) {
          htmlstring = htmlstring.replace(
              new RegExp("img-load-1", "g"),
              "img-load-" + exerciseWrap.find(".drag-drop-wrap").length
          );
          return htmlstring;
        })
    );

    clonedRow.find("textarea").val("");
    clonedRow.removeClass("hidden js-clone-row");
    clonedRow.insertBefore(clonableRow);
  });

  initContentExercises();

  // Detect if button was focused through keyboard navigation
  var hadKeyboardEvent = true;

  function onKeyDown(e) {
    if (e.metaKey || e.altKey || e.ctrlKey) {
      return;
    }

    hadKeyboardEvent = true;
  }

  function onPointerDown(e) {
    hadKeyboardEvent = false;
  }

  $(document).on(
      "focus",
      ".scroll-to, .btn, .dropdown-toggle, .t3-navbar a, .image-drop",
      function (e) {
        if (hadKeyboardEvent) {
          $(this).addClass("focus-visible");
        }
      }
  );

  $(document).on(
      "blur",
      ".scroll-to, .btn, .dropdown-toggle, .t3-navbar a, .image-drop",
      function (e) {
        $(this).removeClass("focus-visible");
      }
  );

  $(document).on("keydown", onKeyDown);
  $(document).on("mousedown", onPointerDown);
  $(document).on("pointerdown", onPointerDown);
  $(document).on("touchstart", onPointerDown);
});